'use client'

import { DraggableSyntheticListeners } from '@dnd-kit/core'
import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

interface Context {
  attributes: Record<string, any>
  listeners: DraggableSyntheticListeners
  ref(node: HTMLElement | null): void
}

const SortableItemContext = createContext<Context>({
  attributes: {},
  listeners: undefined,
  ref() {},
})

export const SortableItemContextProvider = ({
  attributes,
  children,
  listeners,
  ref,
}: PropsWithChildren<Context>) => {
  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref,
    }),
    [attributes, listeners, ref],
  )

  return <SortableItemContext.Provider value={context}>{children}</SortableItemContext.Provider>
}

export const useSortableItemContext = () => {
  const context = useContext(SortableItemContext)

  if (!context) {
    throw new Error('useSortableItemContext must be used within a SortableItemContextProvider')
  }

  return context
}
